import React from 'react'
import Content from './Content/Content'
import Buttons from './Buttons/Buttons'
import styles from './index.module.sass'
import { Simulation, Tip, DialogType } from 'types/data';
import { SimulationType } from 'types/app';
import { animate } from './animations';
import { CONTENT, BACKGROUND, OPEN, CLOSE } from 'constants/animationConstants';
import Viewer from 'components/Scene/viewer';
import { END_DIALOG } from 'constants/sumilationConstants';

export interface AsideRightProps {
    simulation: Simulation,
    posibleSimulationTypes: string[],
    setSimulationType: Function,
    activeSimulationType: SimulationType
    restartSimulation: Function,
    goToNextSimulation?: Function,
    tip: Tip,
    activeStep: number,
    blockToggler: Boolean,
    viewerApi: Viewer,
    afterLeverAnimationProgress: Boolean,
    positionReady: Boolean,
    setActiveStep?: Function,
    openSimulationSelect: Function,
    unmount: Function,
    activeDialogType: DialogType,
    contentOpened: Boolean,
    setContentOpened: Function,
    activeSimulation: Simulation
}

const AsideRight: React.FunctionComponent<AsideRightProps> = (props) => {
    const { 
        openSimulationSelect, 
        activeDialogType, 
        blockToggler, 
        viewerApi, 
        unmount, 
        activeSimulationType,
        afterLeverAnimationProgress,
        posibleSimulationTypes, 
        setSimulationType,
        restartSimulation,
        contentOpened,
        setContentOpened,
        activeSimulation
    } = props
    
    const [animationItems, setAnimationItems] = React.useState<any>(null)
    const rootItem = React.useRef<HTMLDivElement>(null)

    React.useEffect(() => {
        if(afterLeverAnimationProgress) setContentOpened(false)
    }, [afterLeverAnimationProgress, setContentOpened])
    
    const toggleContentOpened = () => {
        setContentOpened(!contentOpened)
        viewerApi!.blurNode(false)
    }

    React.useEffect(() => {
        setContentOpened(true)
    }, [activeDialogType, setContentOpened])

    const getItems = (type: string) => 
        rootItem.current && rootItem ? 
            rootItem.current.querySelectorAll(`[data-type=${type}]`)
                :
                null
    
    const openSelect = async () => {
        await animate(animationItems, CLOSE)

        await viewerApi.blurNode(true)

        viewerApi.RemoteControler.toggle(false)

        unmount()
        
        openSimulationSelect()
    }

    React.useEffect(() => {
        const animitems = {
            [CONTENT]: getItems(CONTENT),
            [BACKGROUND]: getItems(BACKGROUND)
        }
        
        setAnimationItems(animitems)

        animate(animitems, OPEN)
      }, [rootItem])

      
    return (
        <>
            <div className={styles.root} ref={rootItem}>
                <div className={styles.wrapper}>
                    <div className={`${styles.content} ${contentOpened ? styles.content_opened : ''}`} data-type={BACKGROUND} >
                        <Content opened={contentOpened} {...props} />
                    </div>
                    <div className={styles.navigation_wrapper}>
                        <div className={styles.navigation} data-type={BACKGROUND}>
                            <Buttons
                                hideToggler={activeSimulation.hideToggler}
                                restartSimulation={restartSimulation}
                                blockToggler={blockToggler}
                                isDone={activeDialogType === END_DIALOG}
                                opened={contentOpened} 
                                openSelect={openSelect} 
                                toggleContentOpened={toggleContentOpened}
                                activeSimulationType={activeSimulationType}
                                posibleSimulationTypes={posibleSimulationTypes}
                                setSimulationType={setSimulationType}
                                />
                        </div>
                    </div>
                </div>   
            </div>
        </>
    )
}

export default AsideRight

